import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const FAQ: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl font-semibold mb-8">{t('faq.title')}</h1>
      <div className="divide-y divide-gray-200">
        <div className="py-4">
          <h2 className="text-xl font-semibold mb-2">{t('faq.question1')}</h2>
          <p className="text-gray-700">{t('faq.answer1')}</p>
        </div>
        <div className="py-4">
          <h2 className="text-xl font-semibold mb-2">{t('faq.question2')}</h2>
          <p className="text-gray-700 line-through">{t('faq.oldanswer2')}</p>
          <br/>
          <p className="text-gray-700">
            <Trans
              i18nKey="faq.answer2"
              components={{
                bold: <span className="font-bold" />,
              }}
            />
          </p>
        </div>
        <div className="py-4">
          <h2 className="text-xl font-semibold mb-2">{t('faq.question3')}</h2>
          <p className="text-gray-700 line-through">{t('faq.oldanswer3')}</p>
          <br/>
          <p className="text-gray-700">
            <Trans
              i18nKey="faq.answer3"
              components={{
                bold: <span className="font-bold" />,
              }}
            />
          </p>
        </div>
        <div className="py-4">
          <h2 className="text-xl font-semibold mb-2">{t('faq.question4')}</h2>
          <p className="text-gray-700 line-through">{t('faq.oldanswer4')}</p>
          <br/>
          <p className="text-gray-700">
            <Trans
              i18nKey="faq.answer4"
              components={{
                bold: <span className="font-bold" />,
              }}
            />
          </p>
        </div>
        <div className="py-4">
          <h2 className="text-xl font-semibold mb-2">{t('faq.question5')}</h2>
          <p className="text-gray-700 line-through">{t('faq.oldanswer5')}</p>
          <br/>
          <p className="text-gray-700">
            <Trans
              i18nKey="faq.answer5"
              components={{
                bold: <span className="font-bold" />,
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
